
export const AIRPORT_SHUTTLE = 'ShuttleOffAirport';

export const AIRPORT = 'Airport';

export const CITY = 'CityDowntown';
